/** Plan/role sub-permissions under branchLocations_3. Legacy bundled ids kept as fallbacks. */
export const fulfillmentSubPermissionByKey = {
  enablePickup: ["enable_pickup", "enable_pickup_curbside"],
  enableDelivery: ["enable_delivery", "enable_pickup_curbside"],
  enableCurbside: ["enable_curbside", "enable_pickup_curbside"],
  isDriveThruEnabled: ["enable_drive_thru", "enable_dine_drive_thru"],
  enableDineIn: ["enable_dine_in", "enable_dine_drive_thru"],
}

export const ORDER_TYPE_TO_FULFILLMENT_KEY = {
  pickup: "enablePickup",
  delivery: "enableDelivery",
  curbside: "enableCurbside",
  "dine-in": "enableDineIn",
  dine_in: "enableDineIn",
  dineIn: "enableDineIn",
  "drive-thru": "isDriveThruEnabled",
  drive_thru: "isDriveThruEnabled",
  driveThru: "isDriveThruEnabled",
}

/** Same order as the branch add/edit fulfillment toggles. */
export const FULFILLMENT_ORDER_TYPE_OPTIONS = [
  { key: "enablePickup", value: "pickup", label: "Pickup" },
  { key: "enableDelivery", value: "delivery", label: "Delivery" },
  { key: "enableCurbside", value: "curbside", label: "Curbside" },
  { key: "isDriveThruEnabled", value: "drive-thru", label: "Drive Thru" },
  { key: "enableDineIn", value: "dine-in", label: "Dine In" },
]

export const getAllowedOrderTypeFilterOptions = branchSubPermissions =>
  FULFILLMENT_ORDER_TYPE_OPTIONS.filter(option =>
    isFulfillmentSubPermissionEnabled(branchSubPermissions, option.key)
  ).map(({ value, label }) => ({ value, label }))

export const isFulfillmentSubPermissionEnabled = (
  branchSubPermissions,
  key
) => {
  const subIds = fulfillmentSubPermissionByKey[key]
  if (
    !subIds ||
    !branchSubPermissions ||
    typeof branchSubPermissions !== "object"
  ) {
    return false
  }
  return subIds.some(id => branchSubPermissions[id]?.isEnabled)
}

export const sanitizeEnableObjByPlan = (enableObj, branchSubPermissions) => {
  if (!branchSubPermissions || typeof branchSubPermissions !== "object") {
    return enableObj
  }
  const next = { ...enableObj }
  Object.keys(fulfillmentSubPermissionByKey).forEach(key => {
    if (
      next[key] &&
      !isFulfillmentSubPermissionEnabled(branchSubPermissions, key)
    ) {
      next[key] = false
    }
  })
  return next
}

export const isOrderTypeAllowedByPlan = (branchSubPermissions, orderType) => {
  const fulfillmentKey = ORDER_TYPE_TO_FULFILLMENT_KEY[orderType]
  if (!fulfillmentKey) return false
  return isFulfillmentSubPermissionEnabled(
    branchSubPermissions,
    fulfillmentKey
  )
}

export const sanitizeOrderTypesByPlan = (
  orderTypes = [],
  branchSubPermissions
) => {
  if (!branchSubPermissions || typeof branchSubPermissions !== "object") {
    return orderTypes
  }
  return (orderTypes || []).filter(type =>
    isOrderTypeAllowedByPlan(branchSubPermissions, type)
  )
}
